import React, { useState, useEffect } from "react";
import { isEmpty, findIndex } from "lodash";
import { withTranslation } from "react-i18next";
import {
  Paper,
  TextField,
  Typography,
  Grid,
  makeStyles
} from "@material-ui/core";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { useCommittees } from "../../../hooks/useCommittees";
import { Select } from "../../Common/Select";
import { useForm } from '../utils/useForm';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20
  }
}));

const Period = ({ t, i18n, onChangeData, spinner, theme }) => {
  const classes = useStyles();
  const [value, setValue] = useState({});

  const { getActiveCommitteesByLanguageId, sanitizeForTable, committeesListSelect } = useCommittees({
    spinner,
  });

  const initialFValues = {
    descriptionTheme: ''
  }

  const validate = (fieldValues = value) => {

    let temp = { ...errors }
    if ('descriptionTheme' in fieldValues)
      temp.descriptionTheme = fieldValues.descriptionTheme ? "" : "A descrição é obrigatoria"
    setErrors({
      ...temp
    })
    if (fieldValues == value)
      return Object.values(temp).every(x => x == "")
  }

  const {
    errors,
    setErrors
  } = useForm(initialFValues, true, validate);

  const {
    getFrequency,
    frequency,
  } = useFormCombos();

  useEffect(() => {
    getActiveCommitteesByLanguageId(i18n.language);
  }, []);

  useEffect(() => {
    if (i18n.language) {
      getFrequency(i18n.language);
    }
  }, [i18n.language]);

  useEffect(() => {
    onChangeData({ ...value });
  }, [value]);

  const handleChangeSelect = (selected, name) => {
    setValue({ ...value, [name]: selected });
  };

  const handleChange = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };

  const findFrequency = (frequencyName) =>
    findIndex(frequency, ["id", frequencyName]);

  const findcommitteesListSelect = (committeeId) =>
    findIndex(committeesListSelect, ["id", committeeId]);

  const fillTheme = (items) => {
    const findFrequencyIdx = findFrequency(items.frequencyId);
    const committeeId = findcommitteesListSelect(items.committeId);

    setValue({
      frequency: findFrequencyIdx !== -1 ? frequency[findFrequencyIdx] : {},
      committee: committeeId !== -1 ? committeesListSelect[committeeId] : {},
      descriptionTheme: items.themeName,
    });
  }

  useEffect(() => {
    if (!isEmpty(theme)) {
      fillTheme(theme);
    }
  }, [theme, committeesListSelect]);

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {t("forms.theme.info")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item lg={3} xs={12}>
          <Select
            id="committee"
            options={sanitizeForTable(committeesListSelect, [])}
            value={value.committee}
            setValue={(value) => handleChangeSelect(value, "committee")}
            label={t("forms.committeeName")}
            error={!value.committee}
            required
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <TextField
            name="descriptionTheme"
            id="descriptionTheme"
            required
            value={value.descriptionTheme}
            error={!value.descriptionTheme}
            onChange={handleChange}
            label={t("forms.theme.theme")}
            autoComplete='off'
            fullWidth
            autoFocus={true}
            InputLabelProps={{ shrink: value.descriptionTheme ? true : false }}
          />
        </Grid>
        <Grid item lg={3} xs={12}>
          <Select
            id="frequency"
            options={frequency}
            value={value.frequency}
            error={!value.frequency}
            required
            setValue={(value) => handleChangeSelect(value, "frequency")}
            label={t("forms.theme.frequency")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withTranslation()(Period);
